import { Observable, Subscription, filter } from 'rxjs';

export interface UserInfoAuth {
  events$: Observable<{ type: string }>;
  userProfile: () => unknown;
  updateUserInfo: () => Promise<void>;
}

export const retryUserInfoOnTokenReceived = (
  auth: UserInfoAuth
): Subscription =>
  auth.events$
    .pipe(
      filter(
        (event) =>
          event.type === 'token_received' && auth.userProfile() === null
      )
    )
    .subscribe(() => {
      void auth.updateUserInfo().catch(() => undefined);
    });
